export default "__VITE_ASSET__BEVYC51v__"